import { z } from "zod";

// Form uses string/null for dates, API uses Date objects
export const staffFormSchema = z.object({
  level_id: z.number().min(1, "Staff level is required"),
  first_name: z.string()
    .min(1, "First name is required")
    .max(100, "First name must be 100 characters or less")
    .regex(/^[a-zA-Z\s\-'.]+$/, "First name can only contain letters, spaces, hyphens, periods, and apostrophes"),
  last_name: z.string()
    .min(1, "Last name is required")
    .max(100, "Last name must be 100 characters or less")
    .regex(/^[a-zA-Z\s\-'.]+$/, "Last name can only contain letters, spaces, hyphens, periods, and apostrophes"),
  preferred_name: z.string()
    .max(100, "Preferred name must be 100 characters or less")
    .refine((val) => !val || /^[a-zA-Z\s\-'.]+$/.test(val), {
      message: "Preferred name can only contain letters, spaces, hyphens, periods, and apostrophes"
    }),
  pronouns: z.string().max(50, "Pronouns must be 50 characters or less"),
  phone: z.string().max(20, "Phone must be 20 characters or less"),
  email: z.string().email("Please enter a valid email address").max(255, "Email must be 255 characters or less"),
  address: z.string().max(500, "Address must be 500 characters or less"),
  emergency_contact_name: z.string()
    .max(100, "Emergency contact name must be 100 characters or less")
    .refine((val) => !val || /^[a-zA-Z\s\-'.]+$/.test(val), {
      message: "Emergency contact name can only contain letters, spaces, hyphens, periods, and apostrophes"
    }),
  emergency_contact_phone: z.string().max(20, "Emergency contact phone must be 20 characters or less"),
  start_date: z.any().nullable().refine((val) => val !== null, {
    message: "Start date is required"
  }),
  end_date: z.any().nullable(),
  birthday: z.any().nullable(),
  hours: z.array(z.object({
    day_of_week: z.number().min(1).max(7),
    start_time: z.string().regex(/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/, "Invalid time format"),
    end_time: z.string().regex(/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/, "Invalid time format"),
    is_active: z.boolean(),
  })).length(7, "Must have hours for all 7 days").refine(
    (hours) => hours.some((hour) => hour.is_active),
    { message: "Please select at least one working day" },
  ),
  services: z.array(z.number()).min(1, "Please select at least one service"),
});
